import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {StepComponent} from '../../step.component';
import {PlanStep} from '../../../services/PlanStep';
import {PlanCoordinate} from '../../../services/plan-coordinate';
import { IResource } from '../../../services/IResource';
import { ResourceService } from '../../../services/resource.service';
import {AttachmentUploadModalComponent} from '../../../../shared/components/attachment-upload-modal/attachment-upload-modal.component';
import {Subscription} from 'rxjs/index';
import {AppLoadingService} from '../../../../app-loading-panel/app-loading.service';
import {StrategiesPermissionsService} from '../../../services/strategies-permissions.service';

@Component({
  selector: 'app-determine-current-reality',
  templateUrl: './determine-current-reality.component.html',
  styleUrls: ['./determine-current-reality.component.scss']
})
export class DetermineCurrentRealityComponent extends StepComponent<IResource> implements OnInit {

  @ViewChild('attachmentUploadModal') private uploadModal: AttachmentUploadModalComponent;

  @Input() strategyId: number;
  private resourcesSubscription: Subscription;

  resources: IResource[] = [];
  evidenceGroups;
  learner;
  institution;
  community;

  constructor(private resourceService: ResourceService,
              private appLoading: AppLoadingService,
              private permService: StrategiesPermissionsService) {
    super(PlanCoordinate.stepBy(PlanStep.DETERMINE_CURRENT_REALITY), resourceService);
  }

  ngOnInit() {
    if (!this.resourcesSubscription) {
      this.resourcesSubscription = this.resourceService.resources$.subscribe((newResources: IResource[]) => {
        this.resources = newResources.filter((resource: IResource) => {
          return resource.evidenceType.toUpperCase().indexOf('DCR') === 0;
        });

       this.groupByCategory();
       this.appLoading.clearLoading();
      });
    }
    this.resourceService.getResources(this.strategyId);
  }

  isViewer(): boolean {
    return this.permService.isUserViewer();
  }

  groupByCategory() {
    this.evidenceGroups = this.resources.reduce((result, item) => {

      const splits = item.evidenceType.split('-');
      // Get category object corresponding to current item from result (or insert if not present)
      const category = result[splits[1]] = result[splits[1]] || {};

      // Get subcategory array corresponding to current item from category object (or insert if not present)
      const subcategory = category[splits[2]] = category[splits[2]] || [];

      // Add current item to current subcategory array
      subcategory.push(item);

      // Return the result object for this iteration
      return result;

    }, {});
    this.learner = [];
    this.institution = [];
    this.community = [];
    // if (this.evidenceGroups['L']) {
      this.learner.push(
        {
          'displayName': 'Learner Achievement',
          'files': this.evidenceGroups['L'] && this.evidenceGroups['L']['LA'] ? this.evidenceGroups['L']['LA'] : [], 'value': 'LA'
        }
      );
      this.learner.push(
        {
          'displayName': 'Learner Perceptions',
          'files': this.evidenceGroups['L'] && this.evidenceGroups['L']['LP'] ? this.evidenceGroups['L']['LP'] : [], 'value': 'LP'
        }
      );
      this.learner.push(
        {
          'displayName': 'Learner Behaviors',
          'files': this.evidenceGroups['L'] && this.evidenceGroups['L']['LB'] ? this.evidenceGroups['L']['LB'] : [], 'value': 'LB'
        }
      );

      this.institution.push(
        {
          'displayName': 'Institution Profile', 'value': 'IP',
          'files': this.evidenceGroups['I'] && this.evidenceGroups['I']['IP'] ? this.evidenceGroups['I']['IP'] : []
        }
      );
      this.institution.push(
        {
          'displayName': 'Stakeholder Perceptions', 'value': 'STP',
          'files': this.evidenceGroups['I'] && this.evidenceGroups['I']['STP'] ? this.evidenceGroups['I']['STP'] : []
        }
      );
      this.institution.push(
        {
          'displayName': 'Student Observations', 'value': 'SP',
          'files': this.evidenceGroups['I'] && this.evidenceGroups['I']['SP'] ? this.evidenceGroups['I']['SP'] : []
        }
      );
      this.community.push(
        {
          'displayName': 'Community Profile Data', 'value': 'CPD',
          'files': this.evidenceGroups['C'] && this.evidenceGroups['C']['CPD'] ? this.evidenceGroups['C']['CPD'] : []
        }
      );

      this.community.push(
        {
          'displayName': 'Community Involvement', 'value': 'CI',
          'files': this.evidenceGroups['C'] && this.evidenceGroups['C']['CI'] ? this.evidenceGroups['C']['CI'] : []
        }
      );
  }


  fetchData() {
    this.appLoading.setLoading();
    this.resourceService.getResources(this.strategyId);
  }

  showAttachmentUploadModal(categoricalLocation) {
    this.uploadModal.show(categoricalLocation);
  }

  showAttachmentEditModal(event: { categoricalLocation: string,
                                   resource: IResource}) {
    this.uploadModal.edit(event.categoricalLocation, event.resource);
  }


  editResource(resource: IResource) {
    this.appLoading.setLoading();
    this.resourceService.editResource(resource).subscribe((res) => {
        this.resourceService.getResources(this.strategyId);
        this.appLoading.clearLoading();
      }, (err) => {
        console.log('Edit Err: ', err);
        this.resourceService.getResources(this.strategyId);
      this.appLoading.clearLoading();
        this.uploadModal.close();
      }
    );
  }

}
